import { stdObject } from "../../../data/types/stdObject";

export const insertNewPerson = (code: string, params: stdObject) => {
  const { t, mainColor, openWindow } = params;
  const newType = code === "RES" ? "CLI" : code;
  openWindow({
    msgName: "personItem",
    modalInfo: {
      title: t(`p.new${newType}`, {
        code: code === "PRO" ? t("p.supplier") : t("p.customer"),
      }),
      mainColor,
      type: newType,
      doc: newType,
      isEdit: 3,
      code: "",
      insertInDoc: code,
    },
    level: 1,
  });
};
